import script from "./music.vue?vue&type=script&lang=ts&setup=true"
export * from "./music.vue?vue&type=script&lang=ts&setup=true"

import "./music.vue?vue&type=style&index=0&id=0b8574fd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8574fd"]])

export default __exports__